// This query fetches a list of comments based on the company details
import { graphql } from "@/graphql/codegen/gql"

graphql(`
  mutation CreateCommentMutation($input: CommentCreateInput!) {
    comment {
      create(input: $input) {
        ... on CommentCreateSuccess {
          createdComment {
            commentId
            referenceId
            type
            value
            isActive
            createdOn
            createdByUser {
              name
              email
            }
            updatedOn
          }
        }
        ... on CommentCreateFailure {
          error {
            message
          }
        }
      }
    }
  }
`)
